const Login = () => import("@/pages/login")
const Logout = () => import("@/pages/logout")
const AppHeader = () => import("@/routes/index.vue")
const Map = () => import("@/pages/maps/index.vue")
const Catalog = () => import("@/pages/catalog/index.vue")
const CatalogByType = () => import("@/pages/catalog/components/index.vue")
const CatalogFormByType = () => import("@/pages/catalog/components/form.vue")

export default [
  {
    path: "/",
    component: AppHeader,
    name: "AppHeader",
    redirect: "/map",
    children: [
      {
        path: "map",
        component: Map,
        name: "map",
        meta: {
          title: "Карта",
          history: "area-assignments/change-logs",
          historyTitle: "История изменений ежедневного отчета работ",
        },
      },
      {
        path: "catalog",
        name: "Catalog",
        redirect: "/catalog/fields",
        component: Catalog,
        children: [
          {
            path: ":type",
            component: CatalogByType,
          },
          {
            path: ":type/form",
            component: CatalogFormByType,
          },
          {
            path: ":type/form/:id",
            component: CatalogFormByType,
          }
        ]
      }
    ],
  },
  {
    path: "/login",
    component: Login,
    meta: {
      auth: false,
      login: true,
      title: "Вход"
    },
  },
  {
    path: "/logout",
    component: Logout,
    meta: {
      title: "Выход"
    },
  },
]
